import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { ReactComponent as Logo } from "../images/logo.svg";

const Footer = () => {
    return (
        <footer className='mt-32 mb-32'>
            <div className="mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    {/* Logo and Beta Section */}
                    <div className="md:col-span-1">
                        <div className="flex flex-col space-y-6">
                            <Link className="w-16" to="/">
                                <Logo />
                            </Link>
                            <div className="self-start px-3 py-1 rounded-full text-nn-teal-700 bg-nn-teal-50 text-sm font-medium">
                                Beta versie
                            </div>
                        </div>
                    </div>
                    {/* Main Content Section */}
                    <div className="md:col-span-1 space-y-6">
                        <div className="space-y-4">
                            <h3 className="text-nn-500 font-semibold mb-2">Over deze tool</h3>
                            <p className="text-nn-gray-600 text-sm">
                                Deze tool analyseert en vat uitspraken samen van de Stichting Code Geneesmiddelenreclame (CGR).
                                Het doel is om juristen, marketeers en compliance officers snel inzicht te geven in relevante
                                beslissingen en de bijbehorende overwegingen.
                            </p>
                            <p className="text-nn-gray-600 text-sm">
                                De samenvattingen worden gegenereerd met behulp van kunstmatige intelligentie.
                                Hoewel de tool zorgvuldig is ontwikkeld, kunnen samenvattingen onvolledigheden of
                                onjuistheden bevatten. Raadpleeg altijd de originele uitspraken voor de volledige context.
                            </p>
                        </div>
                    </div>
                    {/* Handige Links Section */}
                    <div className="md:col-span-1 space-y-6">
                        <div className="space-y-4">
                            <h3 className="text-nn-500 font-semibold mb-2">Handige links</h3>
                            <div className="space-y-2">
                                {/* CGR Resources */}
                                <a
                                    href="https://www.cgr.nl/home"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    CGR website
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                <a
                                    href="https://mwpkmlumjrauwywhfgfo.supabase.co/storage/v1/object/public/pdf-uploads/Bundel%20Gedragscode%20Jan%201%202024%20(1).pdf"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Gedragscode (pdf)
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                <a
                                    href="https://www.transparantieregister.nl/home"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Transparantieregister
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                {/* Regulatory Bodies */}
                                <a
                                    href="https://www.igj.nl"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1 mt-4"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    IGJ
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                <a
                                    href="https://www.cbg-meb.nl"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    CBG-MEB
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                {/* Tools */}
                                <a
                                    href="https://notebooklm.google.com/notebook/6f584665-0acb-4850-b6d3-f5cc5c5f3cbf"
                                    className="text-nn-gray-600 hover:text-nn-500 text-sm flex items-center gap-1 mt-4"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Chatbot
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* Contact Section */}
                    <div className="md:col-span-1 space-y-6">
                        <div>
                            <h3 className="text-nn-500 font-semibold mb-2">Contact</h3>
                            <p className="text-nn-gray-600 text-sm">
                                Heb je vragen of suggesties?
                                <a href="mailto:maurits@patroon.nl" className="text-nn-500 hover:text-nn-600 block mt-1">
                                    Neem contact op
                                </a>
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-nn-gray-500">
                                Een samenwerking tussen het compliance team van Novo Nordisk en{' '}
                                <a
                                    href="https://www.patroon.nl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-nn-500 hover:text-nn-600 inline-flex items-center gap-1"
                                >
                                    Patroon
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                                , een legal tech en design bureau gespecialiseerd in het maken van juridische tools.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;